import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { useAlgoTileId, useValidateAlgo } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { OmsFieldErrorWrapper } from '@/components/ui/OmsFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectAlgoClippingMode, selectAlgoErrors } from '@/store/orders/algoOrders/selectors.ts';
import { CLIPPING_MODES, type ClippingMode } from '@/store/orders/algoOrders/state.ts';

export const AlgoClippingMode = () => {
  const tileId = useAlgoTileId();
  const track = useTrackEvent();

  const clippingMode = useAppSelector((state) => selectAlgoClippingMode(state, tileId));

  const validateAlgo = useValidateAlgo();

  const errors = useAppSelector((state) => selectAlgoErrors(state, tileId));
  const clippingModeError = errors?.clippingMode;

  const handleChangeClippingMode = (event: React.ChangeEvent<HTMLSelectElement>) => {
    track('Order action', 'Clipping mode changed');
    const newClippingMode = event.target.value as ClippingMode;

    validateAlgo({
      clippingMode: newClippingMode,
    });
  };

  return (
    <OrderRow labelId="order.fields.clippingMode">
      <OmsFieldErrorWrapper errors={clippingModeError}>
        <Form.Select value={clippingMode} onChange={handleChangeClippingMode} size="sm" data-e2e="clipping-mode-select">
          {CLIPPING_MODES.map((clippingMode) => (
            <option key={clippingMode} value={clippingMode}>
              <FormattedMessage id={`order.fields.clippingMode.${clippingMode}`} />
            </option>
          ))}
        </Form.Select>
      </OmsFieldErrorWrapper>
    </OrderRow>
  );
};
